<div class="form"
     [class.is-provincie-viewer]="isProvincieGebruiker$ | async"
     [formGroup]="planregistratieForm">

  @if (invalidGemeenteSelectedMessage$ | async; as invalidGemeenteMessage) {
    <tm-error-message [message]="invalidGemeenteMessage"></tm-error-message>
  }

  <div class="form-field__columns">
    <div class="column">
      <mat-form-field>
        <mat-label>Plannaam</mat-label>
        <input matInput formControlName="plannaam" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Plaatsnaam</mat-label>
        <input matInput formControlName="plaatsnaam" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Gemeente</mat-label>
        @if (((gemeentes$ | async) || []).length > 0) {
          <mat-select formControlName="gemeente">
            <mat-option></mat-option>
            @for (gemeente of gemeentes$ | async; track gemeente.naam) {
              <mat-option [value]="gemeente.naam">{{gemeente.naam}}</mat-option>
            }
          </mat-select>
        } @else {
          <input matInput formControlName="gemeente" />
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Regio</mat-label>
        <input matInput formControlName="regio" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Provincie</mat-label>
        <input matInput formControlName="provincie" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Plantype</mat-label>
        <mat-select formControlName="plantype">
          <mat-option></mat-option>
          @for (item of lists.plantype; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="column">
      <mat-form-field>
        <mat-label>Vertrouwelijkheid</mat-label>
        <mat-select formControlName="vertrouwelijkheid">
          <mat-option></mat-option>
          @for (item of lists.vertrouwelijkheid; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Status Project</mat-label>
        <mat-select formControlName="status_project">
          <mat-option></mat-option>
          @for (item of lists.projectstatus; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Status Planologisch</mat-label>
        <mat-select formControlName="status_planologisch">
          <mat-option></mat-option>
          @for (item of lists.statusPlanologisch; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Knelpunten Meerkeuze</mat-label>
        <mat-select multiple="true" formControlName="knelpunten_meerkeuze">
          @for (item of lists.knelpuntenMeerkeuze; track $index) {
            <mat-option [value]="item">
              @if (item === 'Anders') {
                Anders (vul Opmerking veld in)
              } @else {
                {{item}}
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Beoogd Woonmilieu Abf 13</mat-label>
        <mat-select formControlName="beoogd_woonmilieu_abf13">
          <mat-option></mat-option>
          @for (item of lists.woonmilieuAbf13; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="narrow">
        <mat-label>Aantal Studentenwoningen</mat-label>
        <input matInput formControlName="aantal_studentenwoningen" />
      </mat-form-field>
    </div>
    <div class="column">
      <mat-form-field>
        <mat-label>Opdrachtgever</mat-label>
        <mat-select formControlName="opdrachtgever_type">
          <mat-option></mat-option>
          @for (item of lists.opdrachtgever; track $index) {
            <mat-option [value]="item">{{item}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Opdrachtgever Naam</mat-label>
        <input matInput formControlName="opdrachtgever_naam" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Sleutelproject</mat-label>
        <mat-select formControlName="sleutelproject">
          <mat-option [value]="null"></mat-option>
          <mat-option [value]="true">Ja</mat-option>
          <mat-option [value]="false">Nee</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="opmerkingen">
        <mat-label>Opmerkingen</mat-label>
        <textarea matInput formControlName="opmerkingen"></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
